import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Table, Button, Grid, IconButton } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";

import { NavLink as RouteNavLink } from "react-router-dom";
import { NavLink } from "shards-react";
import { Delete } from "@material-ui/icons";
const useStyles = makeStyles({
  heading: {
    fontFamily: "Noto Sans Malayalam, sans-serif",
    fontSize: "14px",
    fontWeight: "600",
    color: "#3D5279"
  },
  text: {
    fontFamily: "Noto Sans Malayalam, sans-serif",
    fontSize: "14px"
  },
  type: {
    backgroundColor: "yellow",
    padding: "5px",
    fontSize: "10px"
  }
});
const baseUrl = process.env.REACT_APP_API_URI;

export default function ProdectListView(props) {
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
          <TableCell className={classes.heading}>Image</TableCell>

            <TableCell className={classes.heading}>Product Code</TableCell>

            <TableCell className={classes.heading}>Description</TableCell>
            <TableCell className={classes.heading}>Category</TableCell>
            <TableCell className={classes.heading}>Weave</TableCell>

            <TableCell className={classes.heading}>Plates</TableCell>
            <TableCell className={classes.heading}>Season</TableCell>
            <TableCell className={classes.heading}>Qty</TableCell>
            <TableCell className={classes.heading}>Cost</TableCell>


            {/* <TableCell className={classes.heading}>Color</TableCell> */}
            <TableCell className={classes.heading}>Remarks</TableCell>
          </TableRow>
        </TableHead>
        {props && props.products && (
          <TableBody>
            {props.products.map(note => (
              <TableRow key={note.id}>
                <TableCell className={classes.text}>
                  {note.product &&
                    note.product.Images &&
                    note.product.Images.map(image => (
                      <Grid item container>
                        <img
                          style={{ height: "150px", width: "100%" }}
                          src={image.url}
                        />
                      </Grid>
                    ))}
                </TableCell>
                <TableCell className={classes.text} component="th" scope="row">
                  {note.product ? note.product.Name : note.id}
                </TableCell>
                <TableCell className={classes.text}>
                  {note.product && note.product.Description}
                </TableCell>

                <TableCell className={classes.text}>
                  {note.product && note.product.category &&  note.product.category.Name}
                </TableCell>
                
                <TableCell className={classes.text}>
                  {note.product && note.product.Weave}
                </TableCell>
                <TableCell className={classes.text}>
                  {note.product && note.product.Plates}
                </TableCell>
                <TableCell className={classes.text}>
                  {note.product && note.product.Season}
                </TableCell>

                {/* <TableCell className={classes.text}>
                  {note.product && note.product.Color}
                </TableCell> */}


                <TableCell className={classes.text}>
                  {note.ProposedQty}
                </TableCell>

                <TableCell className={classes.text}>
                  {note.ProposedCost}
                </TableCell>

                <TableCell className={classes.text}>
                  {note.ProductNotes}
                </TableCell>

                
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
}
